<template>
  <div class="content-libros-detalle">
    <!-- TESTIMONIOS -->
    <div :class="bImgMobile ? 'z-index-4' : ''" id="testimonios"
      class="content-testimonios">
      <div style="position: relative">
        <carousel v-if="slider.length > 0" :dots="false" :nav="false" :draggable="false" :items="3" :responsive="responsiveCarousel"
          :loop="true">
          <div v-for="(item, index) in slider" :key="index" class="content-card-carousel">
            <p class="txt-comentario" v-html="item.comentario" />
            <p class="txt-persona" v-html="item.persona" />
            <div class="image-testimonio">
              <img :src="item.image" />
            </div>
          </div>
          <!-- hidde buttons -->
          <template slot="prev">
            <span ref="buttonPrev"></span>
          </template>
          <template slot="next">
            <span ref="buttonNext"></span>
          </template>
        </carousel>
        <!-- show buttons -->
        <div class="buttons-carousel">
          <v-btn icon rounded elevation="0" class="carousel-button-left" :ripple="false"
            @click="$refs.buttonPrev.click()">
            <v-icon size="80px" color="#A3332C"> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn icon rounded elevation="0" class="carousel-button-right ml-2" :ripple="false"
            @click="$refs.buttonNext.click()">
            <v-icon size="80px" color="#A3332C"> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  name: "LibrosDetalle",
  data: () => ({
    bgColor: "blue",
    widthContentImg: 0,
    heightImg: 130,
    bgSize: 70,
    bgPosition: 10,
    bImgMobile: false,
    screenWidth: 0,
    slider: [
      // {
      //   comentario:
      //     "Magnífica obra que motiva a nuestros niños a ser creativos.",
      //   persona: "Dr. Héctor Arriaga Flores",
      //   puesto: "Pediatra",
      //   image: require("@/assets/images/icons/feliz-derecha.svg"),
      // }
    ],
    responsiveCarousel: {
      0: { items: 1, nav: false },
      425: { items: 1, nav: false },
      600: { items: 2, nav: false },
      960: { items: 2, nav: false },
      1264: { items: 3, nav: false },
      1636: { items: 4, nav: false },
      1904: { items: 4, nav: false },
    },
    items: [
      {
        backgroundImage: `url(${require("@/assets/images/libro1.png")})`,
        image: require("@/assets/images/libro1.png"),
        link: "el-punto-animado",
        title: "el punto animado",
        subtitle: "LITERATURA INFANTIL",
        description:
          "Es increible que una palabra con connotaciones diminuias pueda tener tan diversos y ricos significados, asi como la fuerza para inspirar un cuento. <br/> <br/> “Pinto del <span class='font-style-italica'>latin punctum</span>, puede ser una señal pequeña en forma de circulo, puede ser un lugar o sitio de concurrencia, indicar un instante o un momento, determinar un valor. ser la parte importante de un asunto, el fin de una acción o de una frase.1<br/> <span class='font-style-italica' >El punto es tiempo</span>, espacio y materia articulados, es un respiro, una pausa. En su cuento El punto animado, María Fernanda le ha dotado al mismo de alma y de movimiento, obteniendo un resultado divertido, vivo. Tal vez un soplo en términos espirituales.<br/> El “punto” del cuento, es la soledad sin posibilidad de acción y el encuentro con el otro como cura y catalizador de crecimiento. La espera va <span class='font-style-italica'>in crescendo</span> y nos conduce a la tensión que conlleva experimentar la inmovilidad. El discurso que se devela en <span>El punto animado</span> es propio de los estados traumáticos, en donde el tiempo se percibe suspendido y el cuerpo experimenta un estado de congelamiento. María Fernanda transmite de una manera natural y estética la soledad infantil, que cuando es profunda, imposibilita el paso de eventos subsecuentes.<br/> Los elementos que entran en la conversación son totalmente sorpresivos. Otros “puntos acompañan al personaje principal. El tiempo es presentado como gran aliado ya que en forma de estaciones, propicia cambios.<br/> Aparece una voz, la Hoja Blanca como una figura femenina simbolizando una madre/abuela, que alientan como soplo hacia la transformación. Esta <span style='font-style: italic;'>ánima</span> nos recuerda al Génesis: “En un principio fue el verbo”. <br/> Los dibujos son una delicia ya que en su sencillez está su estética y capacidad de conectividad con el mundo infantil al cual está dirigido. El personaje de Punto hace honor a su nombre realizando una pausa para respirar y explorar sus dudas. La duda cartesiana asalta a nuestro pequeño Punto: no tenemos posibilidad de conocer la verdad. No hay caminos seguros o ciertos, sólo nuestros propios caminos. Según R. Descartes se puede dudar de todo menos de que (ego) existimos: <span style='font-style: italic;'>cogito ergo sum</span>. <br/> Lo maravilloso del cuento de María Fernanda es que va más allá. Existimos a través de la conjunción puntual de nuestras ideas, nuestros sentimientos y la belleza de la fantasía. El comienzo de un cambio es experimentar la necesidad del mismo. <br/> El mundo interior de las emociones con frecuencia es un mundo fantasmal y sólo siendo agente se le domina. La apropiación del “sí mismo” es a través de palabras y acciones intencionales, siendo ello un signo de cambio psíquico, el <span style='font-style: italic;'>self as agency</span>. <br/> Esta enseñanza es la que María Fernanda trasmite con tanta dulzura y sencillez. <br/> Hacer pausas para pensar nuestras dudas, el manejo del tiempo, la acción, aceptación y crecimiento interior inspiran al pequeño a que escuche este cuento va que únicamente a través de las historias podemos asomarnos a los abismos de lo humano y descubrir la esperanza del valor de la vida.",
        linkAmazon: "https://www.amazon.com.mx/El-punto-animado-Spanish-Mai/dp/B09WWFNJWN",
      },
      {
        backgroundImage: `url(${require("@/assets/images/libro2.png")})`,
        image: require("@/assets/images/libro2.png"),
        link: "politicamente-incorrecta-primer-semestre",
        title: "Políticamente incorrecta",
        subtitle: "PRIMER SEMESTRE",
        description:
          "Tras meterse en problemas con la autoridad en París durante las vacaciones de verano en la Copa del Mundo 1998, las dificultades envuelven a Isabela, una escandalosa <span style='font-style: italic;'>socialité mexicana</span>, mayor de edad, proveniente de una familia conservadora de San Pedro Garza García. Ante el “qué dirán” dentro del círculo provinciano, sus padres deciden mandarla a estudiar a Suiza al colegio de protocolo y etiqueta más prestigioso y exclusivo del mundo: el Institut Léman. El objetivo: refinar sus modales y convertirla en una dama de primer nivel como “las de hierro”. A través de los entrañables vínculos que forma con el personal del colegio y las amistades multiculturales, Isabela aprenderá a resolver con ingenio, decisión y mucho orgullo mexicano cada una de sus aventuras cargadas de lecciones de madurez que la marcarán de por vida. Este es el primer tomo de la serie <span style='font-style: italic;'>Políticamente incorrecta</span>, una novela escrita con picardía, humor ligero y mucha diversión sin dejar de lado la importancia de los valores, el aprendizaje y la condición humana.",
        linkAmazon:
          "https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Mar%C3%ADa-Fernanda-Garc%C3%ADa-ebook/dp/B09T86RT33/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3MQNH6FEMNRSN&keywords=politicamente+incorrecta&qid=1646075814&sprefix=politicamente+incorrect%2Caps%2C193&sr=8-1",
      },
      {
        backgroundImage: `url(${require("@/assets/images/libro3.png")})`,
        image: require("@/assets/images/libro3.png"),
        link: "politicamente-incorrecta-segundo-semestre",
        title: "Políticamente incorrecta",
        subtitle: "SEGUNDO SEMESTRE",
        description:
          "Después de unas breves vacaciones navideñas en México, Isabela vuelve a Suiza para reanudar estudios en el Institut Léman, colegio de protocolo y etiqueta por excelencia. Los retos, las adversidades y los problemas se multiplican, crecen y se acentúan para la protagonista. A pesar de ello, sus objetivos no cambian: desea refinar modales y convertirse en una dama. Esto se vuelve una obsesión. Madurar no es un proceso fácil ni rápido, especialmente al convivir entre amistades de diversas costumbres, religiones e idiosincrasias. Sumado a ello, la joven conoce muchachos de su edad, entre los cuales descubre a Mâlik. En su perspectiva, todo parece un cuento de hadas. Sin embargo, una cadena de eventos desafortunados y situaciones de riesgo a las que se expone provocan que Isabela encuentre su dama de hierro interior y muestre lo mejor de sí. Sin dejar el humor característico de la protagonista, la autora nos guía por paisajes multiculturales aderezados por la natural problemática juvenil, donde el decidido orgullo mexicano resuelve cada una de las aventuras cargadas de lecciones de madurez. El segundo tomo de la serie <span style='font-style: italic;'>Políticamente incorrecta</span>, una novela escrita con picardía y mucha diversión, subraya la importancia de los valores, el aprendizaje y la condición humana.",
        linkAmazon:
          "https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Mar%C3%ADa-Fernanda-Garc%C3%ADa-ebook/dp/B09T8KM27Y/ref=sr_1_2?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3MQNH6FEMNRSN&keywords=politicamente+incorrecta&qid=1646075814&sprefix=politicamente+incorrect%2Caps%2C193&sr=8-2",
      },
    ],
    oBook: {},
  }),
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    window.addEventListener("scroll", this.fixed);
    this.fixed();
  },
  beforeMount() {
    this.getReseñas();
  },
  destroyed() {
    window.removeEventListener("scroll", this.fixed);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    fixed: function () {
      this.$nextTick(() => {
        if (this.$route.path == "/libros/el-punto-animado") {
          let fixed_div = document.getElementById("fixed-content");
          let libros =
            document.getElementById("libros").offsetTop -
            (window.scrollY + 100);
          let testimonios =
            document.getElementById("testimonios").offsetTop - 700;
          if (window.innerWidth > 960) {
            if (libros > -testimonios) {
              fixed_div.style.transform = `translateY(${-libros}px)`;
            }
          }
        }
      });
    },
    handleResize() {
      if (window.innerWidth > 959.99) {
        this.$nextTick(() => {
          if (this.$route.path == "/libros/el-punto-animado") {
            let fixed_div = document.getElementById("fixed-content");
            if (window.innerWidth < 960) {
              fixed_div.style.transform = "none";
            } else {
              this.fixed();
            }
          }
        });
        this.bImgMobile = false;
      } else {
        this.widthContentImg = window.innerWidth - 55;
        this.bImgMobile = true;
        if (window.innerWidth < 639.99) {
          this.bgSize = 45;
          this.heightImg = 1;
          this.bgPosition = 15;
        } else {
          this.bgSize = 70;
          this.heightImg = 130;
        }
      }
    },
    cssContentImg() {
      return {
        width: this.widthContentImg + "px",
      };
    },
    cssImg() {
      return {
        "background-size": this.bgSize + "vh",
        "min-height": this.heightImg + "px",
        "background-position": "50% " + this.bgPosition + "%",
      };
    },
    getBook() {
      let slink = this.$route.params.name;
      this.book = this.items.find((x) => x.link === slink);
    },
    getReseñas() {
      let params = {
        // sSearch: this.sSearch,
      };
      DB.get(`${URI}/messages`, {
        params,
        headers: {
          Authorization: "Bearer " + this.$store.state.sToken,
        },
      })
        .then((response) => {
          this.slider = response.data.messages.map((e) => {
            return {
              comentario: e.sMessage,
              persona: e.sName,
              puesto: e.sJobDescription,
              image: this.getImgBook(e.iBook),
            }
          });
          this.$store.commit("refresher", false);
        })
        .catch((error) => {
          this.Error(error.response.data.message);
        });
    },
    getImgBook(iBook) {
      switch (iBook) {
        case 1:
          // return require("@/assets/images/libro1.png");
          return require("@/assets/images/libros/Libro3.png");

        case 2:
          return require("@/assets/images/libros/Libro2.png");
        case 3:
          return require("@/assets/images/libros/Libro1.png");

        default:
          return require("@/assets/images/img-placeholder.png");
      }
    },
  },
  components: { carousel },
};
</script>

<style>
.content-testimonios .owl-carousel .owl-stage {
  padding-top: 20px !important;
}

.content-testimonios .owl-item {
  height: 0;
}

.content-testimonios .owl-item.active {
  height: auto;
}

.parallax {
  position: relative;
  background-color: black;
  background-attachment: fixed;
  background-repeat: no-repeat;
  height: 100%;
}

.content-img-box {
  position: fixed;
  /* background-color: blue; */
  display: flex;
  place-content: center;
  width: 100%;
  height: 50%;
  max-height: 50%;
  min-height: 50%;
  z-index: 4px;
}

.img-box {
  object-fit: cover;
  position: absolute;
  height: 90%;
  max-height: 90%;
  min-height: 90%;
}

.z-index-4 {
  z-index: 4;
  background-color: white;
  position: relative;
}

.z-index-2 {
  z-index: 2;
}
</style>

<style scoped>
.fixed-content {
  width: 100%;
  height: 500px;
}

.fixed-content img {
  width: 100%;
  height: auto;
}

@supports (object-fit: contain) {
  .fixed-content img {
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
}

.image-testimonio {
  position: absolute !important;
  top: -5px;
  left: 50%;
  margin: -25px 0 0 -25px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 100%;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px !important;
  max-height: 50px !important;
  min-height: 50px !important;
  width: 50px !important;
  max-width: 50px !important;
  min-width: 50px !important;
}

.image-testimonio img {
  width: 50px !important;
  height: 50px !important;
}

.buttons-carousel {
  position: absolute;
  z-index: 1;
  bottom: 320px;
  width: 100%;
  height: 100%;
  top: 0;
}

.carousel-button-left {
  width: 200px;
  position: absolute;
  left: 0;
  background: transparent linear-gradient(270deg, #fafafa00 0%, #fafafa 100%) 0% 0% no-repeat padding-box;
  padding-left: 100px;
  height: 100%;
  border-radius: 0px;
}

.carousel-button-right {
  width: 200px;
  position: absolute;
  right: 0;
  background: transparent linear-gradient(270deg, #fafafa 0%, #fafafa00 100%) 0% 0% no-repeat padding-box;
  padding-right: 100px;
  height: 100%;
  border-radius: 0px;
}

.carousel-button-right::before,
.carousel-button-left::before {
  background: transparent !important;
}

.content-card-carousel {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  opacity: 1;
  margin: 10px;
  padding: 20px;
  position: relative;
  max-height: 230px;
  min-height: 230px;
}

.txt-comentario {
  text-align: left;
  font-size: 18px;
  letter-spacing: 0.14px;
  color: #000000;
  text-align: justify;
  text-justify: inter-word;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}

.txt-persona,
.txt-puesto {
  position: absolute;
  bottom: 0px;
  right: 5px;
  left: 5px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.11px;
  color: #737373;
  text-align: center;
}

.slide-row {
  flex-wrap: inherit;
  overflow-x: auto;
}

.txt-testimonios {
  text-align: left;
  font-size: 70px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.content-testimonios {
  /* background-color: #fafafa; */
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;
}

.content-button-amazon {
  margin-bottom: 100px;
}

.button-amazon {
  background: #a3332c 0% 0% no-repeat padding-box !important;
  border-radius: 4px;
  font-size: 18px;
  width: 100%;
  text-transform: initial;
  color: #fff;
  height: 40px !important;
}

.separator {
  border: 1px solid #e2e2e2;
  margin-top: 30px;
  margin-bottom: 30px;
}

.content-libros-detalle {
  margin-top: 6px;
}

.txt-title {
  text-align: left;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-size: 45px;
  text-transform: uppercase;
  margin-right: 10px;
}

.txt-title::first-letter {
  font-size: 50px;
}

.txt-subtitle {
  text-align: left;
  letter-spacing: 11px;
  color: #000000;
  opacity: 1;
  font-size: 18px;
  margin-right: 10px;
}

.txt-subtitle::first-letter {
  font-size: 23px;
}

.txt-description {
  text-align: left;
  letter-spacing: 0.16px;
  line-height: 2;
  color: #212121;
  /* background-color: blue; */

  opacity: 1;
  font-size: 16px;
  text-align: justify;
  text-justify: inter-word;
}

@media (max-width: 600px) {
  .wrap-txt {
    flex-wrap: wrap;
  }
}

@media (max-width: 960px) {
  .content-title {
    place-content: center;
    justify-content: center;
  }

  .txt-title {
    text-align: left;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-size: 45px;
    text-transform: uppercase;
    margin-right: 10px;
    text-align: center;
  }

  .content-subtitle {
    place-content: center;
    justify-content: center;
  }

  .txt-subtitle {
    text-align: left;
    letter-spacing: 11px;
    color: #000000;
    opacity: 1;
    font-size: 18px;
    margin-right: 10px;
    text-align: center;
  }

  .fixed-content {
    width: 100%;
    height: 400px;
  }

  @supports (object-fit: contain) {
    .fixed-content img {
      height: 100%;
      object-fit: contain;
      object-position: center center;
    }
  }

  .carousel-button-left {
    padding-left: 4px !important;
    width: fit-content;
  }

  .carousel-button-right {
    padding-right: 4px !important;
    width: fit-content;
  }
}

@media (min-width: 961px) and (max-width: 1260px) {
  .carousel-button-left {
    padding-left: 4px !important;
    width: fit-content;
  }

  .carousel-button-right {
    padding-right: 4px !important;
    width: fit-content;
  }
}
</style>